import {
  BaseValueFacet,
  RailsFacet,
} from '@sls-react/typings/services/rails/facets';
import { RailsCategory } from '@sls-react/typings/services/rails/item';

export function getDetailById<T extends BaseValueFacet[] | RailsCategory[]>(
  details: T | undefined | null,
  id?: number | string,
): undefined | null | T[number] {
  let match: null | RailsFacet = null;

  if (!details || !Array.isArray(details)) {
    return match;
  }

  details.some(val => {
    if (val.id == id) {
      match = val;
      return true;
    }

    if (val.children) {
      const recursiveResult = getDetailById(val.children, id);
      if (recursiveResult) {
        match = recursiveResult;
        return true;
      }
    }
  });

  return match;
}
